var KDatepicker = function () {};

(function ($) {

    kDatePicker = function(elem) {
        var currVals, day, month, year;
        currVals = $(elem).val().split('-');

        if(currVals.length != 3){
            day = '01';
            month = '01';
            year = '1970';
        } else {
            day = currVals[0];
            month = currVals[1];
            year = currVals[2];
        }

        $('#k_datepicker_day').html(day);
        $('#k_datepicker_month').html(month);
        $('#k_datepicker_year').html(year);


        $('#k_datepicker')
            .attr('data-comp', $(elem).attr('id'))
            .css('top', $(elem).offset().top + $(elem).height() + 10)
            .css('left', $(elem).offset().left);

        $('#k_datepicker_ct').hide().fadeIn();
        $('#k_datepicker').hide().slideDown('fast');
    };


    /*
     * Public API
     **********************************************************************/

    KDatepicker.datePicker = function(elem) {
        if($('body').find('#k_datepicker').length == 0){
            var html = '<div id="k_datepicker_ct"><div id="k_datepicker">';

            html += '<div id="k_datepicker_slider"><div id="k_datepicker_day_plus"></div>';
            html += '<div id="k_datepicker_month_plus"></div>';
            html += '<div id="k_datepicker_year_plus"></div>';
            html += '<div id="k_datepicker_day"></div>';
            html += '<div id="k_datepicker_month"></div>';
            html += '<div id="k_datepicker_year"></div>';
            html += '<div id="k_datepicker_day_minus"></div>';
            html += '<div id="k_datepicker_month_minus"></div>';
            html += '<div id="k_datepicker_year_minus"></div></div>';
            html += '<div id="k_datepicker_actions"><div id="k_datepicker_ok"></div><div id="k_datepicker_cancel"></div></div>';
            html += '</div></div>';

            $('body').append(html);

            // Add events
            $('#k_datepicker_day_plus').click(function() {
                KDatepicker.updateDate('d', true);
            });

            $('#k_datepicker_month_plus').click(function() {
                KDatepicker.updateDate('m', true);
            });

            $('#k_datepicker_year_plus').click(function() {
                KDatepicker.updateDate('y', true);
            });

            $('#k_datepicker_day_minus').click(function() {
                KDatepicker.updateDate('d', false);
            });

            $('#k_datepicker_month_minus').click(function() {
                KDatepicker.updateDate('m', false);
            });

            $('#k_datepicker_year_minus').click(function() {
                KDatepicker.updateDate('y', false);
            });

            $('#k_datepicker_ok').click(function() {
                $('#' + $('#k_datepicker').attr('data-comp')).val($('#k_datepicker_day').html() + '-' + $('#k_datepicker_month').html() + '-' + $('#k_datepicker_year').html());

                $('#k_datepicker_ct').hide();
            });

            $('#k_datepicker_cancel').click(function() {
                $('#k_datepicker_ct').hide();
            });

            $('#k_datepicker_ct').click(function(e){
                e.preventDefault();

                if($(e.target).attr('id') == 'k_datepicker_ct'){
                    $(this).hide();
                }
            });

            if(window.addEventListener){
                window.addEventListener('DOMMouseScroll', KDatepicker.wheel, false);
            }

            window.onmousewheel = document.onmousewheel = KDatepicker.wheel;
        }

        $(elem).keypress(function(e){
            e.preventDefault();

            // Check if is number
            if(e.charCode >= 48 && e.charCode <= 57){
                var currVal = $(this).val() + String.fromCharCode(e.charCode);

                if(currVal.length > 10){
                    return;
                }

                if(currVal.length == 2 || currVal.length == 5){
                    currVal += '-';
                } else if(currVal.length == 5){
                    currVal += '-';
                }

                $(this).val(currVal);
            }
        });

        $(elem).focus(function () {
            kDatePicker($(this));
        });

        $(elem).blur(function () {
            $('#k_datepicker_ct').hide();
        });
    };


    KDatepicker.updateDate = function(datePart, increment) {

        var dayElem = $('#k_datepicker_day');
        var monthElem = $('#k_datepicker_month');
        var yearElem = $('#k_datepicker_year');

        var day = parseFloat(dayElem.html());
        var month = parseFloat(monthElem.html());
        var year = parseFloat(yearElem.html());

        // Adjust month to 0-11 range
        month--;

        var currDate = new Date();
        currDate.setFullYear(year);
        currDate.setMonth(month);
        currDate.setDate(day);

        switch (datePart) {
            case 'd':
                if (increment == true) {
                    currDate.setDate(currDate.getDate() + 1);
                } else {
                    currDate.setDate(currDate.getDate() - 1);
                }
                break;

            case 'm':
                if (increment == true) {
                    currDate.setMonth(currDate.getMonth() + 1);
                } else {
                    currDate.setMonth(currDate.getMonth() - 1);
                }
                break;

            case 'y':
                if (increment == true) {
                    currDate.setFullYear(currDate.getFullYear() + 1);
                } else {
                    currDate.setFullYear(currDate.getFullYear() - 1);
                }
                break;
        }

        dayElem.html(KDatepicker.addLeadingZero(currDate.getDate()));
        monthElem.html(KDatepicker.addLeadingZero(currDate.getMonth() + 1));
        yearElem.html(currDate.getFullYear());

        //$('#' + $('#k_datepicker').attr('data-comp')).val(dayElem.html() + '-' + monthElem.html() + '-' + yearElem.html());
    };


    KDatepicker.addLeadingZero = function(value) {
        var newValue = '';

        if (parseFloat(value) < 10) {
            newValue += '0' + value;
        } else {
            newValue += value;
        }

        return newValue;
    };


    KDatepicker.wheel = function (event){

        if(event.target.id === "undefined" && event.target.parentElement.id === undefined){
            return;
        }

        var delta = 0;
        if (!event) event = window.event;
        if (event.wheelDelta) {
            delta = event.wheelDelta/120;
        } else if (event.detail) {
            delta = -event.detail/3;
        }

        if(delta){
            /* DATE */
            if(event.target.id !== "undefined"){
                if(event.target.id == 'k_datepicker_day')
                    KDatepicker.updateDate('d', delta > 0);
            }

            if(event.target.parentElement !== undefined && event.target.parentElement != null){
                if(event.target.parentElement.id !== undefined && event.target.parentElement.id == 'k_datepicker_day'){
                    KDatepicker.updateDate('d', delta > 0);
                }
            }

            /* MONTH */
            if(event.target.id !== "undefined"){
                if(event.target.id == 'k_datepicker_month')
                    KDatepicker.updateDate('m', delta > 0);
            }

            if(event.target.parentElement !== undefined && event.target.parentElement != null){
                if(event.target.parentElement.id !== undefined && event.target.parentElement.id == 'k_datepicker_month'){
                    KDatepicker.updateDate('m', delta > 0);
                }
            }

            /* YEAR */
            if(event.target.id !== "undefined"){
                if(event.target.id == 'k_datepicker_year')
                    KDatepicker.updateDate('y', delta > 0);
            }

            if(event.target.parentElement !== undefined && event.target.parentElement != null){
                if(event.target.parentElement.id !== undefined && event.target.parentElement.id == 'k_datepicker_year'){
                    KDatepicker.updateDate('y', delta > 0);
                }
            }
        }

        /*
        if (delta && (event.target !== undefined || event.target.parentElement !== undefined)){
            if(event.target.id == 'k_datepicker_day' || event.target.parentElement.id ==  'k_datepicker_day'){
                KDatepicker.updateDate('d', delta > 0);
            } else if(event.target.id == 'k_datepicker_month' || event.target.parentElement.id ==  'k_datepicker_month'){
                KDatepicker.updateDate('m', delta > 0);
            }else if(event.target.id == 'k_datepicker_year' || (event.target.parentElement && event.target.parentElement.id ==  'k_datepicker_year')){
                KDatepicker.updateDate('y', delta > 0);
            }
        }
        */
    };

})(jQuery);